
import Vue from 'vue';
import OpeningHoursContent from '@/components/map/OpeningHoursContent.vue';

export default Vue.extend({
	name: 'OpeningHoursDialog',

	components: {
		OpeningHoursContent
	},

	props: {
		value: {
			type: Boolean,
			required: true
		},
		isMobile: {
			type: Boolean,
			required: true
		},
		canExtend: {
			type: Boolean,
			default: false
		},
		truck: {
			type: Object,
			default: null
		}
	},

	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			}
		}
	},

	methods: {
		handleOutsideClick() {
			this.$emit(this.canExtend ? 'cancel-extend' : 'cancel-selection');
		},
		handleEscapeKey(e: KeyboardEvent) {
			e.stopPropagation(); // Prevent the event from propagating to parent dialogs
			this.$emit(this.canExtend ? 'cancel-extend' : 'cancel-selection');
		},
		extendBooking() {
			this.$emit('extend-booking');
		},
		findNearbyLocation() {
			console.log('OpeningHoursDialog: findNearbyLocation method called');
			this.$emit('find-nearby-location');
		},
		cancelSelection() {
			this.$emit('cancel-selection');
		}
	}
});
